import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tyt-article-tag',
  templateUrl: './article-tag.component.html',
  styleUrls: ['./article-tag.component.scss']
})
export class ArticleTagComponent implements OnInit {

  constructor() { }j

  ngOnInit() {
  }

}
